export const ImageReport = {
  camerasAreNotConfigured:
    "The selected cameras are not configured to detect entries and/or exits.",
  eventType: "Event type",
  eventState: "Event state",
  pdfDisclaimer:
    "Note: Some images have been omitted from this report to enhance performance. To view all images, please access the application.",
  filterType: "Filter type",
  filterTypeSubject: "Type",
  filterTypeState: "State",
};
